export default{pill:"w_DE",indicator:"w_DF",on:"w_DG",label:"w_DH"};
